import React from 'react';
import { Flex, Image, Text } from '@skin-seoul/design-system';
import { CLASSNAME } from '@skin-seoul/service';
import shieldIcon from './assets/shield.png';
import packageIcon from './assets/package.png';
import { resolveImageSrc } from '../../../utils';

export function CartTrustBadges() {
  return (
    <Flex gap={2} alignItems="center" justifyContent="center" width="100%" flexWrap="wrap" paddingY={2}>
      <Flex
        alignItems="center"
        gap={2}
        backgroundColor="primary.50"
        borderRadius="36px"
        paddingLeft={3}
        paddingRight={4}
        paddingY={1}
      >
        <Image
          src={resolveImageSrc(shieldIcon)}
          alt="Authenticity Guarantee"
          width="24px"
          height="24px"
          flexShrink={0}
        />
        <Text
          textStyle="label.small"
          fontWeight="medium"
          color="neutral.800"
          className={CLASSNAME.NOT_TRANSLATE}
        >
          Authenticity Guarantee
        </Text>
      </Flex>
      <Flex
        alignItems="center"
        gap={2}
        backgroundColor="primary.50"
        borderRadius="36px"
        paddingLeft={3}
        paddingRight={4}
        paddingY={1}
      >
        <Image
          src={resolveImageSrc(packageIcon)}
          alt="Easy Returns"
          width="24px"
          height="24px"
          flexShrink={0}
        />
        <Text
          textStyle="label.small"
          fontWeight="medium"
          color="neutral.800"
          className={CLASSNAME.NOT_TRANSLATE}
        >
          Easy Returns
        </Text>
      </Flex>
    </Flex>
  );
}
